/**
 * User types
 */

export enum UserRole {
  ADMIN = 'ADMIN',
  ONSHORE_HR = 'ONSHORE_HR',
  OFFSHORE_HR = 'OFFSHORE_HR',
  ONSHORE_IT = 'ONSHORE_IT',
  OFFSHORE_IT = 'OFFSHORE_IT',
  IT_SUPPORT = 'IT_SUPPORT', // Legacy role
  EMPLOYEE = 'EMPLOYEE',
}

export interface User {
  user_id: number;
  employee_id?: number;
  username: string;
  email: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
  role: UserRole;
  is_active: boolean;
  profile_picture?: string;
  created_at?: string;
  updated_at?: string;
}

export interface UserCreate {
  username: string;
  email: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
  password: string;
  role: UserRole;
}

export interface UserUpdate {
  username?: string;
  email?: string;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  role?: UserRole;
  is_active?: boolean;
}
